// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const GROUP_ASKED_TO_JOIN = "Po\u017e\u00e1dala jsi o \u010dlenstv\u00ed";
export const GROUP_ASK_TO_JOIN = "Po\u017e\u00e1dej o \u010dlenstv\u00ed";
export const GROUP_YOU_ARE_BLOCKED = "P\u0159\u00edstup do skupiny ti byl zru\u0161en\u00fd";
export const JOIN_GROUP = "P\u0159idej se ke skupin\u011b";
export const LEAVE_GROUP = "Opustit skupinu";
export const num_POSTS_AND_ANSWERS_IN_LAST_WEEK = ["%(num)s \u010dlov\u011bk p\u0159isp\u011bl za t\u00fdden", "%(num)s lid\u00e9 p\u0159isp\u011bli za t\u00fdden", "%(num)s lid\u00ed p\u0159isp\u011blo za t\u00fdden"];
